import { useAtom } from "jotai";
import { TileLayer } from "react-leaflet";
import { activeBaselayerAtom } from "src/atoms/baselayers";

export function BaselayerOnMap() {
  const [activeBaselayer] = useAtom(activeBaselayerAtom);

  if (!activeBaselayer) return null;
  else
    return (
      <TileLayer
        key={activeBaselayer.key}
        url={activeBaselayer.url}
        attribution={activeBaselayer.attribution}
        zIndex={0}
      />
    );
}
